module.exports = __webpack_public_path__ + "assets/trip-white.7fdecbcc.svg";